/**
 * Feedback Submission Functionality
 *
 * Handles saving user mood feedback via AJAX
 */

export function initFeedbackSubmit() {
	const form = document.getElementById('feedback-form');

	if (!form) {
		return;
	}

	const saveBtns = document.querySelectorAll('[data-action="post-feedback"]');

	saveBtns.forEach((saveBtn) => {
		saveBtn.addEventListener('click', async (e) => {
			e.preventDefault();

			// 1. Collect form data
			const formData = new FormData(form);

			// 2. Validation
			const rating = formData.get('rating');
			if (!rating) {
				if (window.wpcore?.alert) {
					window.wpcore.alert('error', wpcore.direct_t({ en: 'Oops!', fr: 'Oups !' }), wpcore.direct_t({ en: 'Please select a rating before posting.', fr: 'Veuillez sélectionner une note avant de poster.' }));
				}
				saveBtn.disabled = false;
				saveBtn.textContent = originalText;
				return;
			}

			// 3. Logic: Only Send short_description if rating is 1 or 10
			const ratingValue = parseInt(rating);
			if (ratingValue === 1 || ratingValue === 10) {
				const selected = form.querySelector(`input[name="rating"][value="${ratingValue}"]`);
				const container = selected.closest('.wrapper-rating');
				const description = container ? container.querySelector('.content')?.textContent.trim() : '';
				if (description) {
					formData.append('short_description', description);
				}
			}

			// Disable button and show loading state
			saveBtn.disabled = true;
			const originalText = saveBtn.textContent;
			saveBtn.textContent = wpcore.direct_t({ en: 'Posting...', fr: 'Publication en cours...' });

			try {
				// 4. Prepare data for AJAX
				formData.append('action', 'save_feedback');
				formData.append('journey_id', form.dataset.journeyId);
				formData.append('stage_id', form.dataset.stageId);

				// Send AJAX request
				const result = await submitFeedback(formData);

				if (result.success) {
					if (window.wpcore?.alert) {
						window.wpcore.alert(
							'success',
							wpcore.direct_t({ en: 'Thank You!', fr: 'Merci !' }),
							wpcore.direct_t({ en: 'Your feedback has been saved.', fr: 'Votre avis a \u00e9t\u00e9 enregistr\u00e9.' }),
						);
					}
					saveBtn.textContent = originalText;


				} else {
					if (window.wpcore?.alert) {
						window.wpcore.alert(
							'error',
							wpcore.direct_t({ en: 'Oops!', fr: 'Oups !' }),
							result.data.message || wpcore.direct_t({ en: 'Failed to post feedback.', fr: 'Échec de la publication de l\'avis.' }),
						);
					}
					saveBtn.disabled = false;
				}
			} catch (error) {
				console.error('Post failed:', error);
				if (window.wpcore?.alert) {
					window.wpcore.alert(
						'error',
						wpcore.direct_t({ en: 'Oops!', fr: 'Oups !' }),
						wpcore.direct_t({ en: 'An error occurred while posting. Please try again.', fr: 'Une erreur est survenue lors de la publication. Veuillez réessayer.' }),
					);
				}

				saveBtn.disabled = false;
				saveBtn.textContent = originalText;
			}
		});
	});
}

/**
 * Send feedback data to server
 * @param {FormData} formData
 * @returns {Promise<Object>}
 */
async function submitFeedback(formData) {
	const response = await fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData,
	});

	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	return await response.json();
}
